
export const SET_DEFICIENCY_FETCHING = 'SET_DEFICIENCY_FETCHING';
export const SET_DEFICIENCY_SUCCESS = 'SET_DEFICIENCY_SUCCESS';
export const SET_DEFICIENCY_ERROR = 'SET_DEFICIENCY_ERROR';
export const SET_DEFICIENCY_UPDATE_SUCCESS = 'SET_DEFICIENCY_UPDATE_SUCCESS';
export const SET_DEFICIENCY_UPDATE_ERROR = 'SET_DEFICIENCY_UPDATE_ERROR';
export const SET_DEFICIENCY_UPDATE_FETCHING = 'SET_DEFICIENCY_UPDATE_FETCHING';
